import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Loader2, FileText, Calendar } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export default function PortalHistorialOT() {
  const [ots, setOts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  async function load() {
    setLoading(true);
    // Vista que sólo expone campos no sensibles y filtra por cliente
    const { data, error } = await (supabase as any)
      .from('portal_ordenes_trabajo')
      .select('*')
      .order('updated_at', { ascending: false });
    if (error) console.error(error);
    setOts(data ?? []);
    setLoading(false);
  }

  useEffect(() => { load(); }, []);

  const filtered = ots.filter(ot =>
    !q.trim() ||
    ot.titulo?.toLowerCase().includes(q.toLowerCase()) ||
    ot.numero_ot?.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Histórico de trabajos</h1>
        <p className="text-sm text-muted-foreground">Órdenes de trabajo finalizadas en tus instalaciones.</p>
      </div>

      <Input placeholder="Buscar por título o número..." value={q} onChange={e => setQ(e.target.value)} className="max-w-md" />

      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin" /></div>
      ) : filtered.length === 0 ? (
        <Card><CardContent className="py-12 text-center text-muted-foreground">
          <FileText className="h-8 w-8 mx-auto mb-3 opacity-50" />
          {ots.length === 0 ? 'Aún no hay trabajos finalizados.' : 'Sin resultados.'}
        </CardContent></Card>
      ) : (
        <div className="space-y-3">
          {filtered.map(ot => (
            <Card key={ot.id}>
              <CardHeader className="pb-3">
                <div className="flex items-start justify-between gap-2 flex-wrap">
                  <div>
                    <CardTitle className="text-base">{ot.titulo}</CardTitle>
                    <p className="text-xs text-muted-foreground mt-1">
                      {ot.numero_ot} {ot.tipo_trabajo && <>· <span className="capitalize">{ot.tipo_trabajo}</span></>}
                    </p>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    <Badge>Finalizada</Badge>
                    {ot.prioridad && <Badge variant="outline" className="capitalize">{ot.prioridad}</Badge>}
                  </div>
                </div>
              </CardHeader>
              <CardContent className="space-y-2 text-sm">
                {ot.descripcion && <p className="whitespace-pre-wrap">{ot.descripcion}</p>}
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" /> Creada: {format(new Date(ot.fecha_creacion), "d MMM yyyy", { locale: es })}</span>
                  <span>Última actualización: {format(new Date(ot.updated_at), "d MMM yyyy", { locale: es })}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
